import { useSyncExternalStore } from 'react';

function subscribeNever() {
  return function unsubscribe() {};
}

function readOnClient() {
  return true;
}

function readOnServer() {
  return false;
}

/**
 * `false` during the server render and hydration, `true` after. Nothing ever
 * changes, so the store never notifies and a mounted component doesn't
 * re-render for it.
 */
export function useIsClient(): boolean {
  return useSyncExternalStore(subscribeNever, readOnClient, readOnServer);
}
